const Render = ({ condition, children }) => {

  if (condition) return children;

  return null;
};


export default Render;
